"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryVacationFunds = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const roleVacationQuery = (0, graphql_tag_1.default) `
  query RoleVacation($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      vacation {
        unit
        contractType
        amount
      }
    }
  }
`;
const queryVacationFunds = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(roleVacationQuery, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role.vacation;
};
exports.queryVacationFunds = queryVacationFunds;
